import React, { SyntheticEvent } from 'react'
import { useDispatch } from 'react-redux'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { showPopup } from 'publisher/actionsManagement'
import { getEntityById } from 'publisher/reducers/pageReducer'
import { usePage } from 'publisher/store'
import { dispatchPopupOpenedCustomEvent } from 'publisher/utils/popupUtils'
import { useRemoveUnavailablePopups } from 'src/publisher/hooks/use-remove-unavailable-popups'
import { BasePublisherButton } from 'src/publisher/entities/base-publisher-button'

export const TEST_ID = 'show-popup-button'

export interface ShowPopupButtonProps {
  entity: ButtonInterface
}

const ShowPopupButton = ({ entity }: ShowPopupButtonProps) => {
  const dispatch = useDispatch()
  const popupEntity = usePage(page => getEntityById(page, entity.popup))

  const openPopup = (e: SyntheticEvent) => {
    e.preventDefault()
    if ('popup' in entity && entity.popup) {
      dispatch(showPopup(entity.popup))
    }
    // use small timeout in order to render popup
    if (popupEntity) {
      dispatchPopupOpenedCustomEvent(
        popupEntity.options
          ? popupEntity.options.attrId
          : popupEntity.htmlAttrId,
      )
    }
  }

  useRemoveUnavailablePopups({
    keys: ['popup'],
    entity,
  })

  return (
    <BasePublisherButton entity={entity} onClick={openPopup} testId={TEST_ID} />
  )
}

export default ShowPopupButton
